import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/components/toast/toast.component';
import { I18nService } from './core/services/i18n.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet, 
    ToastComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('b2b-dashboard');
  // Injected for its side effects: I18nService initializes the language in its constructor.
  private readonly i18nService = inject(I18nService);
}
